import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {Moment} from 'moment-timezone'

import {mapTaskRepetitionToTaskRepetitionDto} from '../mappers'
import {Iso8601, TaskPreviewData, TaskRepetition} from '../types'

export const QueryKey = 'task-dueDate-preview'

export const useTaskRepetitionPreview = (
  repetition: TaskRepetition,
  itemsCount = 5,
  plantId: string,
  defaultStartDate?: Moment,
  options?: UseQueryOptions<Iso8601[], AxiosError>
) => {
  const path = `/shifthandover/${plantId}/tasks/duedatespreview`
  return useQuery<Iso8601[], AxiosError>({
    queryKey: [QueryKey, repetition, defaultStartDate, plantId],
    queryFn: async () => {
      if (!repetition) return []

      const data: TaskPreviewData = {
        ...mapTaskRepetitionToTaskRepetitionDto(repetition),
        itemsCount
      }
      if (defaultStartDate) {
        data.startDate = defaultStartDate.toISOString()
      }

      const response = await ApiClient.axiosInstance.post<Iso8601[]>(path, data)
      return response.data
    },
    // hook specific options
    refetchOnMount: false,
    refetchOnWindowFocus: false,

    // allow the caller to override the default options
    ...options
  })
}
